import { Card, CardContent, CardHeader, Tooltip, Typography } from '@mui/material';
import * as React from 'react';
import { IAppCustomer } from '../../../Interfaces/Application/IAppCustomer';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { addThousandsSeparator, hasValue } from '@amsanalytics/react-shared-library';
import { IExistingCustomerInfo } from '../../../Interfaces/Customer/IExistingCustomerInfo';
import {ssnIsNotAllZeroes} from "../../../utils/utils";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
export interface ExistingCustomerInformationProps {
  appCustomers: IAppCustomer[];
}


// Card to display existing customer information, such as existing LOS applications and existing AMS customer details.
export const ExistingCustomerInformation: React.FC<ExistingCustomerInformationProps> = (props) => {
  const validAppCustomers = props.appCustomers.filter(ac => ssnIsNotAllZeroes(ac.customer.ssn));
  
  return (
    <Card style={{ backgroundColor: 'inherit', minHeight: 110, margin: '5px 0' }}>
      <CardHeader
        style={{ background: '#ffc800', padding: '0.2rem .8rem' }}
        avatar={<InfoOutlinedIcon />}
        title={
          // <Typography variant="h6" style={{ fontWeight: "bold" }}>
            'Existing Customer Details'
          // </Typography>
        }
      />
      <CardContent style={{ padding: '10px' }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left">Applicant</TableCell>
                <TableCell align="left">App/AMS #</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {
              validAppCustomers.map((ac: IAppCustomer) => {
                return ac.customer.existingCustomerInfo.map((existingCustomerInfo: IExistingCustomerInfo, idx: number) => {
                  return (
                    <TableRow key={idx}>
                      <TableCell align="left">{ac.customer.firstName} {ac.customer.lastName}</TableCell>
                      <TableCell align="left">
                        {hasValue(existingCustomerInfo.message) && hasValue(existingCustomerInfo.applicationId) 
                          ? <Tooltip title='View this application' placement='right'><a href={`${existingCustomerInfo.applicationId}`}>{addThousandsSeparator(existingCustomerInfo.applicationNumber)}</a></Tooltip>
                          : !hasValue(existingCustomerInfo.message) && hasValue(existingCustomerInfo.applicationId)
                            ? <Tooltip title='View this application' placement='right'><a href={`${existingCustomerInfo.applicationId}`}>{addThousandsSeparator(existingCustomerInfo.applicationNumber)}</a></Tooltip>
                            : !hasValue(existingCustomerInfo.message) && hasValue(existingCustomerInfo.customerNumber)
                              ? <div>{existingCustomerInfo.customerNumber}</div>
                              : <></>
                        }
                      </TableCell>
                    </TableRow>
                    // <li key={idx} style={{ listStyle: 'none', marginBottom: 5 }}>
                    //   <Typography variant='body2'>
                    //     {hasValue(existingCustomerInfo.message) && <span>{existingCustomerInfo.message} <Tooltip title='View this application' placement='right'><a href={`${existingCustomerInfo.applicationId}`}>{existingCustomerInfo.applicationNumber}</a></Tooltip></span>} 
                    //     {!hasValue(existingCustomerInfo.message) && hasValue(existingCustomerInfo.applicationId) && <span><span style={{ fontWeight: 500 }}>{ac.customer.firstName} {ac.customer.lastName}</span> has an existing application: <Tooltip title='View this application' placement='right'><a href={`${existingCustomerInfo.applicationId}`}>{existingCustomerInfo.applicationNumber}</a></Tooltip></span>}
                    //     {!hasValue(existingCustomerInfo.message) && hasValue(existingCustomerInfo.customerNumber) && <span><span style={{ fontWeight: 500 }}>{ac.customer.firstName} {ac.customer.lastName}</span> already exists in AMS with customer number: <span style={{ fontWeight: 500 }}>{existingCustomerInfo.customerNumber}</span></span>}
                    //   </Typography>
                    // </li>
                  )
                })
              })
            }
            </TableBody>
            </Table>
          </TableContainer>
        {/* <ul style={{ margin: 0, paddingInlineStart: 0 }}>
          {
            validAppCustomers.map((ac: IAppCustomer) => {
              return ac.customer.existingCustomerInfo.map((existingCustomerInfo: IExistingCustomerInfo, idx: number) => {
                return (
                  <li key={idx} style={{ listStyle: 'none', marginBottom: 5 }}>
                    <Typography variant='body2'>
                      {hasValue(existingCustomerInfo.message) && <span>{existingCustomerInfo.message} <Tooltip title='View this application' placement='right'><a href={`${existingCustomerInfo.applicationId}`}>{existingCustomerInfo.applicationNumber}</a></Tooltip></span>} 
                      {!hasValue(existingCustomerInfo.message) && hasValue(existingCustomerInfo.applicationId) && <span><span style={{ fontWeight: 500 }}>{ac.customer.firstName} {ac.customer.lastName}</span> has an existing application: <Tooltip title='View this application' placement='right'><a href={`${existingCustomerInfo.applicationId}`}>{existingCustomerInfo.applicationNumber}</a></Tooltip></span>}
                      {!hasValue(existingCustomerInfo.message) && hasValue(existingCustomerInfo.customerNumber) && <span><span style={{ fontWeight: 500 }}>{ac.customer.firstName} {ac.customer.lastName}</span> already exists in AMS with customer number: <span style={{ fontWeight: 500 }}>{existingCustomerInfo.customerNumber}</span></span>}
                    </Typography>
                  </li>
                )
              })
            })
          }
        </ul> */}
      </CardContent>
    </Card>
  );
}
